import { Select } from '@any-ui-react/core';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import { SELECT_FONT_SIZE } from './FontSizePlugin';

const FONT_SIZE_OPTIONS = [
  { label: '14', value: 'sm' },
  { label: '16', value: 'md' },
  { label: '19', value: 'lg' },
  { label: '22', value: 'xl' },
  { label: '28', value: 'xxl' },
];

export const DEFAULT_FONT_SIZE = 'md';

export function FontSizeSelect({ value }: { value: string }) {
  const [editor] = useLexicalComposerContext();

  return (
    <Select
      value={value}
      className="w-14"
      size="xs"
      data={FONT_SIZE_OPTIONS}
      onChange={(fontSize) => {
        if (!fontSize) return;
        editor.dispatchCommand(SELECT_FONT_SIZE, { fontSize });
        editor.focus();
      }}
    />
  );
}
